<template>
  <div class="Edit">

    <LoadingLayout v-if="!page || !notification" :page="true" />

    <template v-if="notification">
      <Page
        :title="`${(notification.status == 'draft' || notification.type === 'welcome') ? $t('Editing') : $t('Viewing')} ${$t('Notification')} '${notification ? notification.name : '...'}'`"
      >

        <Layout v-if="notification.type !== 'template'" class="Notifications-progress" size="full">
          <LayoutSection>
            <Card>
              <CardSection>
                <ul>
                  <li :class="{ 'active': page === 'filters' }" @click="tryToGoToPage('filters')"><span class="bullet">1</span><span class="text">{{($t('Filters'))}}</span></li>
                  <li :class="{ 'active': page === 'details', 'disabled': notification && notification.creationStep < 2 }" @click="tryToGoToPage('details')"><span class="bullet">2</span><span class="text">{{$t('Details')}}</span></li>
                  <li :class="{ 'active': page === 'scheduling', 'disabled': notification && notification.creationStep < 3 }" @click="tryToGoToPage('scheduling')"><span class="bullet">3</span><span class="text">{{notification && notification.type === 'welcome'  ? this.$t('Activate') : this.$t('Scheduling')}}</span></li>
                </ul>
              </CardSection>
            </Card>
          </LayoutSection>
        </Layout>

        <edit-filters v-if="page === 'filters' && notification" :notification="notification" @update="updateFromFilters" @goToPage="goToPage" ref="pageFilters"></edit-filters>
        <edit-details v-if="page === 'details' && notification" :notification="notification" @update="updateFromDetails" @goToPage="goToPage" ref="pageDetails"></edit-details>
        <edit-scheduling v-if="page === 'scheduling' && notification" :notification="notification" @update="updateFromSchedule" @goToPage="goToPage" ref="pageScheduling"></edit-scheduling>

      </Page>
    </template>

  </div>
</template>

<script>

// import _ from 'lodash'
// import OsBrowser from '@/data/OsBrowser'
import EditFilters from './EditFilters.vue'
import EditDetails from './EditDetails.vue'
import EditScheduling from './EditScheduling.vue'

export default {
  name: 'Edit',
  data() {
    return {
      page: '',
      notification: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.page = to.params.page
    next()
  },
  mounted() {
    // load current notification
    NProgress.start()
    this.api.notifications.getNotification(this.$route.params.id)
      .then((response) => {
        this.notification = response.notifications[0]
        this.page = this.$route.params.page
      })
      .catch((error) => {
        this.apiCatch(error)
      })
      .finally(() => {
        NProgress.done()
      })
  },
  methods: {
    goToPage(page) {
      if (this.notification) {
        const creationStep = this.notification.creationStep
        if (page === 'details' && creationStep < 2) return
        if (page === 'scheduling' && creationStep < 3) return
        this.$router.push(`/notifications/edit/id/${this.notification.notificationId}/page/${page}/`)
        this.page = page
      }
    },
    tryToGoToPage(page) {
      let ref
      if (page === this.page) {
        return
      } else if (this.page === 'filters') {
        ref = this.$refs.pageFilters
      } else if (this.page === 'details') {
        ref = this.$refs.pageDetails
      } else if (this.page === 'scheduling') {
        ref = this.$refs.pageScheduling
      }
      if ((page === 'details' && this.notification.creationStep < 2) || (page === 'scheduling' && this.notification.creationStep < 3)) {
        return
      }
      if (ref) {
        let forceSave = true
        if (this.notification.status === 'active') {
          forceSave = false
        }
        ref.changePage(page, forceSave)
      }
    },
    updateFromFilters(newDetails) {
      // no editing
      if (this.notification.status !== 'draft' && (this.notification.type !== 'welcome')) {
        this.goToPage(newDetails.nextPage)
        return
      }
      if (newDetails.chosenOsBrowser.length === 0) {
        this.$ui.alert({ title: this.$t('NotificationsApp.Please select at least one Browser / OS') })
        return
      }
      if (newDetails.language.length === 0) {
        this.$ui.alert({ title: this.$t('NotificationsApp.Please select a language') })
        return
      }
      this.notification.filters = JSON.stringify(newDetails.filters)
      this.notification.segments = this.notification.segments || {}
      this.notification.segments.browserLanguage = newDetails.language
      // this.notification.segments.tz = newDetails.timezone
      this.notification.segments.domain = newDetails.domain
      this.notification.segments.startDate = `${newDetails.startDate} 00:00:00`
      this.notification.segments.endDate = `${newDetails.endDate} 00:00:00`
      this.notification.isBroadcastMessage = newDetails.isBroadcastMessage
      const chosenOsBrowser = newDetails.chosenOsBrowser
      const osBrowserCombinations = {}
      chosenOsBrowser.forEach((id) => {
        const s = id.split('-')
        const os = s[0]
        const browser = s[1]
        if (!osBrowserCombinations[os]) {
          osBrowserCombinations[os] = []
        }
        if (osBrowserCombinations[os].indexOf(browser) === -1) {
          osBrowserCombinations[os].push(browser)
        }
      })
      this.notification.segments.osBrowserCombinations = osBrowserCombinations
      if (this.notification.creationStep < 2) {
        this.notification.creationStep = 2
      }
      // update ...
      NProgress.start()
      this.api.notifications.updateNotification(this.notification)
        .then((response) => {
          this.notification = response.notifications[0]
          this.goToPage(newDetails.nextPage)
          NProgress.done()
        })
        .catch((error) => {
          this.apiCatch(error.message)
          NProgress.done()
        })
    },
    updateFromDetails(newDetails) {
      // no editing)
      if (this.notification.status !== 'draft' && this.notification.type !== 'template') {
        this.goToPage(newDetails.nextPage)
        return
      }
      if (this.notification.creationStep < 3) {
        this.notification.creationStep = 3
      }
      this.notification.definition = JSON.parse(JSON.stringify(newDetails.definition))
      //
      if (newDetails.nextPage === 'activateTemplate') {
        this.notification.status = 'active'
      }
      //
      NProgress.start()
      this.api.notifications.updateNotification(this.notification)
        .then((response) => {
          this.notification = response.notifications[0]
          if (newDetails.nextPage === 'saveTemplate') {
            this.$router.push('/notifications/list/type/template/status/draft/')
          } else if (newDetails.nextPage === 'activateTemplate') {
            this.$router.push('/notifications/list/type/template/status/active/')
          } else {
            this.goToPage(newDetails.nextPage)
          }
          NProgress.done()
        })
        .catch((error) => {
          this.apiCatch(error.message)
          NProgress.done()
        })
    },
    updateFromSchedule(newDetails) {
      // no editing
      this.notification.schedule.date = newDetails.date
      this.notification.schedule.time = newDetails.time
      this.notification.schedule.optimizeToUserTZ = newDetails.optimizeToUserTZ
      this.notification.schedule.triggerElapsedTime = newDetails.triggerElapsedTime

      if (this.notification.status !== 'draft' && (this.notification.type !== 'welcome')) {
        this.goToPage(newDetails.nextPage)
        return
      }
      if (this.notification.creationStep < 4) {
        this.notification.creationStep = 4
      }
      if (newDetails.nextPage === 'send') {
        this.notification.status = 'scheduled'
      }
      if (newDetails.nextPage === 'activateWelcome' || newDetails.nextPage === 'activateTriggered') {
        this.notification.status = 'active'
      }

      NProgress.start()
      this.api.notifications.updateNotification(this.notification)
        .then((response) => {
          this.notification = response.notifications[0]
          if (newDetails.nextPage === 'send') {
            this.$router.push('/notifications/list/type/manual/status/scheduled/')
          } else if (newDetails.nextPage === 'save') {
            this.$router.push('/notifications/list/type/manual/status/draft/')
          } else if (newDetails.nextPage === 'activateWelcome') {
            this.$router.push('/notifications/list/type/welcome/status/active/')
          } else if (newDetails.nextPage === 'activateTriggered') {
            this.$router.push('/notifications/list/type/triggered/status/active/')
          } else if (newDetails.nextPage === 'saveWelcome') {
            this.$router.push('/notifications/list/type/welcome/status/draft/')
          } else if (newDetails.nextPage === 'saveTriggered') {
            this.$router.push('/notifications/list/type/triggered/status/draft/')
          } else {
            this.goToPage(newDetails.nextPage)
          }
          NProgress.done()
        })
        .catch((error) => {
          this.apiCatch(error.message)
          NProgress.done()
        })
    }
  },
  components: {
    EditFilters,
    EditDetails,
    EditScheduling
  }
};
</script>

<style lang="less">
  .Notifications-progress {
    margin-bottom: 15px;

    ul {
      display: flex;
      list-style-type: none;
      padding: 0;
      li {
        flex: 1;
        width: auto;
        display: flex;
        cursor: pointer;
        justify-content: center;
        margin-left: 5px;
        margin-right: 5px;
        padding: 10px;
        &.disabled {
          color: #ccc;
          cursor: auto;
          .bullet {
            background: #ccc;
          }
        }
        .bullet {
          display: inline-block;
          background: #aaa;
          color: #fff;
          width: 25px;
          height: 25px;
          padding-top: 1px;
          border-radius: 50%;
          text-align: center;
          flex: 0 0 25px;
        }
        .text {
          display: inline-block;
          margin-left: 15px;
          margin-top: 2px;
        }
        &.active {
          .bullet {
            background: #ff9800;
          }
          .text {
            color: #ff9800;
          }
        }
      }
    }
  }
  .loading {
    text-align: center;
    padding: 30px;
    padding-bottom: 150px;
  }
</style>
